/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Driver } from '../models/Driver';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverService {
    /**
     * @param userUId
     * @returns Driver OK
     * @throws ApiError
     */
    public static getApiDriver(
        userUId: number,
    ): CancelablePromise<Driver> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Driver/{userUId}',
            path: {
                'userUId': userUId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Driver OK
     * @throws ApiError
     */
    public static postApiDriver(
        requestBody?: Driver,
    ): CancelablePromise<Driver> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Driver',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiDriver(
        id: number,
        requestBody?: Driver,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Driver/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param fileType
     * @param userUid
     * @param formData
     * @returns any OK
     * @throws ApiError
     */
    public static postApiDriverUploadDriverPhoto(
        fileType?: string,
        userUid?: number,
        formData?: {
            photo?: Blob;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Driver/UploadDriverPhoto',
            query: {
                'fileType': fileType,
                'userUID': userUid,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param userUId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiDriverApproveApply(
        userUId?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Driver/ApproveApply',
            query: {
                'userUId': userUId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postApiDriverApplyLead(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Driver/ApplyLead',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param userUId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiDriverApproveLeadApply(
        userUId?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Driver/ApproveLeadApply',
            query: {
                'userUId': userUId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param teamCode
     * @returns any OK
     * @throws ApiError
     */
    public static getApiDriverTeamDrivers(
        teamCode?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Driver/TeamDrivers',
            query: {
                'teamCode': teamCode,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param teamCode
     * @param keyword
     * @returns any OK
     * @throws ApiError
     */
    public static getApiDriverSearchDrivers(
        teamCode?: string,
        keyword?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Driver/SearchDrivers',
            query: {
                'teamCode': teamCode,
                'keyword': keyword,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param teamCode
     * @returns any OK
     * @throws ApiError
     */
    public static getApiDriverTeamDriverInfo(
        teamCode?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Driver/TeamDriverInfo',
            query: {
                'teamCode': teamCode,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param fileName
     * @returns any OK
     * @throws ApiError
     */
    public static getApiDriverGetPhoto(
        fileName?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Driver/GetPhoto',
            query: {
                'fileName': fileName,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param userUId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiDriverDisableDriver(
        userUId?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Driver/DisableDriver',
            query: {
                'userUId': userUId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
